import React, { useState, useRef } from "react";
import emailjs from "@emailjs/browser";

const Discuss = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [phone, setPhone] = useState("");

  const form = useRef();

  const subimtHandler = (e) => {
    e.preventDefault();

    // set them to empty values
    setName("");
    setEmail("");
    setSubject("");
    setMessage("");
    setPhone("");

    emailjs
      .sendForm(
        "service_ym072mc",
        "contact-template",
        form.current,
        "XIJYdEIZ6kSu_lJiT"
      )
      .then(
        (result) => {
          console.log("Email sent");
          // console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div className="wpo-project-single-item">
      <div className="wpo-project-contact-area">
        <div className="wpo-contact-title">
          <h2>Vous avez une question?</h2>
          <p>
            Veuillez remplir le formulaire ou nous rejoindre sur les réseaux
            sociaux et nous vous répondrons dans les plus brefs délais.
          </p>
        </div>
        <div className="wpo-contact-form-area">
          <form ref={form} onSubmit={subimtHandler} className="form">
            <div className="row">
              <div className="col col-lg-6 col-md-6 col-12">
                <div className="form-field">
                  <input
                    className="form-control"
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value);
                    }}
                    type="text"
                    name="name"
                    placeholder="Votre Nom"
                  />
                </div>
              </div>
              <div className="col col-lg-6 col-md-6 col-12">
                <div className="form-field">
                  <input
                    className="form-control"
                    onChange={(e) => {
                      setPhone(e.target.value);
                    }}
                    value={phone}
                    type="text"
                    name="phone"
                    placeholder="Télephone"
                  />
                </div>
              </div>
              <div className="col col-lg-12 col-12">
                <div className="form-field">
                  <input
                    className="form-control"
                    onChange={(e) => {
                      setSubject(e.target.value);
                    }}
                    value={subject}
                    type="text"
                    name="subject"
                    placeholder="Objet"
                  />
                </div>
              </div>
              <div className="col col-lg-12 col-12">
                <div className="form-field">
                  <input
                    className="form-control"
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                    value={email}
                    type="email"
                    name="email"
                    placeholder="Email"
                  />
                </div>
              </div>
              <div className="fullwidth col col-lg-12 col-12">
                <textarea
                  onChange={(e) => setMessage(e.target.value)}
                  value={message}
                  className="form-control"
                  name="message"
                  id="note"
                  placeholder="       Message..."
                ></textarea>
              </div>
            </div>
            <div className="submit-area">
              <button type="submit" className="theme-btn-s4">
                Envoyer
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Discuss;
